import { render } from "./upload2.vue?vue&type=template&id=3b18f81b&scoped=true"
import script from "./upload2.vue?vue&type=script&lang=js"
export * from "./upload2.vue?vue&type=script&lang=js"

import "./upload2.vue?vue&type=style&index=0&id=3b18f81b&lang=scss&scoped=true"

import exportComponent from "/usr/src/test-oho-sales/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b18f81b"]])

export default __exports__